@if (item(); as item) {
  <div
    class="p-2 nk-search-dropdown-item"
    [attr.data-cy]="item.person_uuid ? 'company-person-search-person-option' : 'company-person-search-company-option'"
    [class.click-disabled]="disableEnterKey()"
    [class.active]="selectedItemIndex() === item.itemIndex"
    (click)="simpleSearchClickSelect(item)">
    <p class="m-0" style="line-height: 1.2">
      <span class="bigger" [innerHTML]="item.search_label | highlightText: highlightText() : 'highlightText'">
        {{ item.search_label }}
      </span>
      @if (item.confirmed_dead_company_flag) {
        <span class="badge badge-warning"> ({{ 'simple_search.company_deleted' | translate }}) </span>
      }
      <br />
      <span class="text-muted" [innerHTML]="item.search_label_aux | highlightText: highlightText() : 'highlightText'">
      </span>
    </p>
  </div>
}
